import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VIcon,{staticClass:"icon",on:{"click":_vm.openHelp}},[_vm._v("mdi-help-circle-outline")])
}
var staticRenderFns = []

export { render, staticRenderFns }